import { render, staticRenderFns } from "./PillBadgeGlow.vue?vue&type=template&id=3283ff96&"
import script from "./PillBadgeGlow.vue?vue&type=script&lang=js&"
export * from "./PillBadgeGlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports